<template>
	<az-container :class="[corBackground, 'ml-0', 'pa-3', 'mb-1']" fluid>
		<h3 class="title font-weight-bold mt-3 mb-5 color-titulo pl-3">Detalhes da Ata</h3>

		<v-row
			:class="['cabecalho-pagina', 'rounded-tl', 'rounded-tr', corBackground, 'pl-3']"
			justify="center"
			align="center"
			dense
			no-gutters
		>
			<div class="cabecalho w-100">
				<p id="titulo" class="label ma-0">
					<span :class="corTitulo" v-html="descricao.titulo"></span>
				</p>
				<p id="subtitulo" :class="['text', corSubtitulo]">{{ descricao.subtitulo.texto }}</p>
			</div>
			<v-col
				cols="12"
				md="12"
				class="margem d-flex flex-sm-row flex-md-row flex-lg-row flex-column flex-wrap justify-start"
			>
				<div
					v-for="texto in info"
					:id="texto.titulo"
					:key="texto.titulo"
					class="cabecalho"
					:style="{ 'min-width': '20%' }"
				>
					<div v-if="texto.titulo === 'PNCP'" class="cabecalho">
						<p id="titulo" class="label ma-0">
							<span :class="corTitulo" v-html="texto.titulo"></span>
						</p>
						<a v-if="texto.subtitulo.texto" id="subtitulo" :class="['text', 'link-pncp']" target="_blank" :href="texto.subtitulo.texto">
							Clique Aqui
							<v-icon style="font-size: 0.8rem"> open_in_new </v-icon>
						</a>
						<span v-else id="subtitulo" :class="['text']">---</span>
					</div>

					<template v-else>
						<v-list-item class="px-0">
							<v-list-item-content>
								<v-list-item-title id="titulo" class="label">
									<span :class="corTitulo" v-html="texto.titulo"></span>
								</v-list-item-title>
								<v-list-item-subtitle id="subtitulo" :class="['text', corSubtitulo]">
									<texto-tooltip
										:tamanho-maximo="tamanhoMaximoDoSubtitulo"
										:texto="texto.subtitulo.texto"
									></texto-tooltip>
									<span class="ma-1">
										<slot :name="texto.slotName + '_icone'"></slot>
									</span>
								</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
					</template>
				</div>
			</v-col>
		</v-row>
	</az-container>
</template>

<script>
import TextoTooltip from '@/views/components/TextoTooltip'
import { actionTypes, mutationTypes } from '@/core/constants'
import formatDataFilter from '@/views/filters/format-data-filter'
import semModalidadeFilter from '@/views/filters/sem-modalidade-filter'

export default {
	name: 'cabecalho-ata-view',
	components: {
		TextoTooltip,
	},
	data() {
		return {
			corBackground: 'white',
			corTitulo: 'grey--text text--darken-2',
			corSubtitulo: 'grey--text text--darken-1',
			descricao: { titulo: '', subtitulo: { texto: '' }, slotName: '' },
			info: '',
			tamanhoMaximoDoSubtitulo: 100,
		}
	},
	async mounted() {
		await this.criarCabecalho()
	},
	methods: {
		async criarCabecalho() {
			const cabecalhoInfo = await this.carregarInfoCabecalho()
			this.info = [
				{ titulo: 'N° Ata', subtitulo: { texto: cabecalhoInfo.numeroAta }, slotName: 'numeroAta' },
				{ titulo: 'PNCP', subtitulo: { texto: cabecalhoInfo.linkPncp }, slotName: 'linkPncp' },
				{
					titulo: 'Gerenciador',
					subtitulo: { texto: cabecalhoInfo.orgaoGerenciador },
					slotName: 'orgaoGerenciador',
				},
				{
					titulo: 'Modalidade',
					subtitulo: { texto: semModalidadeFilter(cabecalhoInfo.modalidade) },
					slotName: 'modalidade',
				},
				{
					titulo: 'Data Assinatura',
					subtitulo: { texto: this.getDataAssinatura(cabecalhoInfo.dataAssinatura) },
					slotName: 'dataAssinatura',
				},
				{
					titulo: 'Vigência Inicial',
					subtitulo: { texto: formatDataFilter(cabecalhoInfo.inicioVigencia) },
					slotName: 'inicioVigencia',
				},
				{
					titulo: 'Vigência Final',
					subtitulo: { texto: formatDataFilter(cabecalhoInfo.fimVigencia) },
					slotName: 'fimVigencia',
				},
				{ titulo: 'Valor Total', subtitulo: { texto: cabecalhoInfo.valorTotal }, slotName: 'valorTotal' },
			]
			this.descricao = {
				titulo: 'Descrição',
				subtitulo: { texto: cabecalhoInfo.descricao },
				slotName: 'descricao',
			}
			const casasDecimais = {
				qtd: cabecalhoInfo.numeroCasasDecimaisQtde,
				valor: cabecalhoInfo.numeroCasasDecimaisValores,
			}

			this.$store.commit(mutationTypes.COMUM.SET_IS_PODE_ADERIR, cabecalhoInfo.isPodeAderir)
			this.$store.commit(mutationTypes.COMUM.SET_INFO_CABECALHO, this.info)
			this.$store.commit(mutationTypes.CASAS_DECIMAIS.SET_CASAS_DECIMAIS, casasDecimais)
		},
		getDataAssinatura(data) {
			return data ? formatDataFilter(data) : '---'
		},
		async carregarInfoCabecalho() {
			return await this.$store.dispatch(actionTypes.ATA.BUSCAR_INFO_CABECALHO, this.$route.params.id)
		},
	},
}
</script>

<style lang="stylus" scoped>
.cabecalho-pagina
	.cabecalho
		.label
			font-weight bold !important
			font-size 0.75em !important

		.text
			font-size .8em !important

.margem
	margin 0 !important
	padding: 0rem !important;

#subtitulo div:first-child
	float: left !important

#subtitulo-icone i
	margin-left 0.75em !important

.link-pncp
	color: blue
	.v-icon
		color: blue

.w-100
	width: 100%
</style>
